import React from "react";
import Extraitems from "./components/Extraitems";
import { withRouter } from "react-router-dom";
function ExtraItemstable() {
  return <Extraitems></Extraitems>;
}
export default withRouter(ExtraItemstable);
